module.exports = __webpack_public_path__ + "img/150.6a28384c.jpg";